'use strict';

function MoneyUpDashboardHomeMortgage() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MortgageController, _MoneyUpDashboardHomeBase];

  this.presenter = null;
  this.analytics = null;
  this.onComplete = function () {};
  this.contentfulData = null;

  this._connectionIssueConfig = null;
  this._classNames = {
    unavailable: MoneyUpProductCell.classNames.disabled,
    declined: MoneyUpProductCell.classNames.active,
    completeApplication: MoneyUpProductCell.classNames.active,
    pendingReview: MoneyUpProductCell.classNames.inactive,
    preQualified: MoneyUpProductCell.classNames.active,
    dataUnavailable: MoneyUpProductCell.classNames.active
  };
  this._disclaimers = {
    inactive: {
      text: 'disclaimer.mogoMortgageRates'
    }
  };
  this._dataReady = false;
  this._dataReadyCallback = null;

  this.init = function () {
    this._super();
    this._connectionIssueConfig = this._getConnectionIssueConfig();

    // load mortgage rate and term from contentful
    this.contentful = new Contentful(_ContentfulConfiguration, $.extend({}, ContentfulSpaceParams, { verboseLevel: 1 }) // verboseLevel 1 required to have revision # returned.
    );
    this.contentful.getResource('ENTRIES_FROM_MODEL', { model_id: 'featuredMortgageProduct' }, this._onDataReady.bind(this));
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var cellSettings = {
      product: 'MogoMortgage',
      contentExtensions: this._content,
      classNameExtensions: this._classNames,
      disclaimers: this._disclaimers
    };

    this._createProductCell(cellSettings);
    this.onComplete(); // tell page component is loaded
  };

  this._onDataReady = function (contentfulData) {
    this.contentfulData = contentfulData;
    this._dataReady = true;
    this._setState();
  };

  this._setState = function () {
    if (!_this.node.querySelector('.js--dashboard-product').mogo().create && _this._dataReady) {
      _this._productCell = _this._getProductCell();

      var mortgageStatus = _this.presenter.getModelProperty('mortgage.status');
      var mortgageType = mortgageStatus === 'funded' ? _this.presenter.getModelProperty('mortgage_funded.mortgages[0].type') : null;
      var canCreateApplication = _this.presenter.hasAction('account.create_mortgage_application');
      var hasApplication = _this.presenter.hasAction('mortgage_applications.mortgage_applications.length');
      var productState = 'loading';
      var analyticsState = 'Loading';

      if (!mortgageStatus && !canCreateApplication && !hasApplication) {
        productState = 'unavailable'; // A.1.1.3.5
        analyticsState = 'Unavailable';
      } else if (mortgageType && mortgageType === 'variable') {
        productState = 'dataUnavailable';
        analyticsState = 'Static Funded';
      } else {
        switch (mortgageStatus) {
          case 'declined':
            productState = 'declined'; // A.1.1.3.6
            analyticsState = 'Declined';
            break;
          case 'opened':
            productState = 'completeApplication'; // A.1.1.3.10
            analyticsState = 'Complete Application';
            break;
          case 'submitted':
            productState = 'pendingReview'; // A.1.1.3.11
            analyticsState = 'Pending Review';
            break;
          case 'pre_approved':
            productState = 'preQualified'; // A.1.1.3.12
            analyticsState = 'Pre-qualified';
            break;
          case 'funded':
            productState = 'active'; // A.1.1.3.2
            analyticsState = 'Active';
            break;
          default:
            productState = 'inactive'; // A.1.1.3.1
            analyticsState = 'Inactive';
            break;
        }
      }
      _this._productCell.setState(productState, analyticsState);
      // alert scenarios
      _this._setAlertState(analyticsState);
    }
  };

  this._setAlertState = function () {
    if (_this._productCell.getState() === 'active' || _this._productCell.getState() === 'completeApplication' || _this._productCell.getState() === 'pendingReview') {
      var mortgageStatus = _this.presenter.getModelProperty('mortgage.status');
      var mortgageData = _this.presenter.getModelProperty('mortgage_funded.mortgages[0].type');

      if (
      // MogoMortgage is funded without data (i.e. A.1.1.3.2 + A.1.1.3.3)
      mortgageStatus === 'funded' && !mortgageData ||
      // When the user needs to complete their application (i.e. A.1.1.3.10 + A.1.1.3.3)
      mortgageStatus === 'opened' ||
      // When their MogoMortgage is pending review (i.e. A.1.1.3.11 + A.1.1.3.3)
      mortgageStatus === 'submitted') {
        _this._productCell.showAlert(true);
      } else {
        _this._productCell.showAlert(false);
      }
    } else {
      _this._productCell.showAlert(false);
    }
  };

  // dynamic content construction
  this._getInactiveContentString = function () {
    if (_this.contentfulData && _this.contentfulData.items[0] && _this.contentfulData.items[0].mortgageProduct) {
      var intro = 'Daily rate';
      var contentfulRef = _this.contentfulData.items[0].mortgageProduct;
      var rateProduct = contentfulRef.productName;
      var rate = contentfulRef.annualInterestRate;
      var rateString = _this._productCell._getFormattedPercentageHtml(rate);
      return intro + ' (' + rateProduct + ')<br>' + rateString;
    }
  };

  this._getActiveContentString = function () {
    var intro = 'Amount paid this term';
    var amount = _this.presenter.getModelProperty('mortgage_funded.mortgages[0].total_payments_made');
    var moneyString = _this._productCell._getFormattedMoneyHtml(amount);
    return intro + '<br>' + moneyString;
  };

  // define after any methods that are referenced in definition
  this._content = {
    inactive: this._getInactiveContentString,
    active: this._getActiveContentString,
    unavailable: "Sorry, this product isn't available right now",
    dataUnavailable: 'Mortgage details are currently unavailable',
    declined: "Sorry, we can't give you a mortgage right now",
    completeApplication: 'Complete my application',
    pendingReview: 'Pending review',
    preQualified: "Congratulations! You're pre-qualified"
  };

  // Utilities

  this.destroy = function () {
    this._super();
  };
}